import React from "react";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { HuidigeSituatieInkomenLoondienst } from "../../../../.generated/rapportage/rapportagetypes";

export interface InkomensLoondienstTableProps {
  data: HuidigeSituatieInkomenLoondienst[];
}

export const InkomensLoondienstTable: React.FC<InkomensLoondienstTableProps> = ({
  data,
}: InkomensLoondienstTableProps) => {
  // Flatten the data to show each aanvrager as a separate row
  const flattenedData = data.flatMap((item) => item.inkomensPerAanvrager || []);

  // Volgorde en labels exact zoals in BuildInkomenLoondienst (UwGegevensBuilder.cs)
  const columns: Column[] = [
    {
      header: "Inkomen uit dienstverband",
      accessor: "naam",
    },
    {
      header: "Bruto jaarsalaris uit dienstverband",
      accessor: "brutoJaarsalaris",
      dataType: "currency",
    },
    {
      header: "Inkomen wordt meegenomen tot",
      accessor: "inkomenMeegenomenTot",
      dataType: "date",
    },
    {
      header: "Beroepsfunctie",
      accessor: "beroepsfunctie",
    },
    {
      header: "Buitenlands inkomen",
      accessor: "buitenlandsInkomen",
    },
    {
      header: "Intentieverklaring werkgever",
      accessor: "intentieverklaring",
    },
    {
      header: "Datum in dienst",
      accessor: "datumInDienst",
      dataType: "date",
    },
    {
      header: "Einddatum contract",
      accessor: "datumUitDienst",
      dataType: "date",
    },
    {
      header: "Aantal uren per week",
      accessor: "aantalUrenPerWeek",
    },
    {
      header: "Naam werkgever",
      accessor: "werkgeverNaam",
    },
    {
      header: "Adres werkgever",
      accessor: "werkgeverAdres",
    },
    {
      header: "Postcode/plaats werkgever",
      accessor: "werkgeverPostcodePlaats",
    },
    {
      header: "Vestigingsland werkgever",
      accessor: "werkgeverLand",
    },
  ];

  // Split data into chunks of maximum 2 rows
  const chunkSize = 2;
  const chunks: typeof flattenedData[] = [];
  for (let i = 0; i < flattenedData.length; i += chunkSize) {
    chunks.push(flattenedData.slice(i, i + chunkSize));
  }

  return (
    <>
      {chunks.map((chunk, index) => (
        <Table
          key={`inkomens-loondienst-table-${index}`}
          columns={columns}
          data={chunk}
          rotate={true}
          showHeader={true}
          filterNullAnd0Columns={true}
          id={`inkomens-loondienst-table-${index}`}
          regularStyles={chunk?.length > 1}
        />
      ))}
    </>
  );
};
